<template>
  <div>
    <filter-data
      with_client_portfolios
      with_envelope_number
      with_text_search
      text_search_label="Pesquisar"
      :months_before="0"
      :months_after="0"
      skip_date_range_rule
      :initial_date_start="custodyDateStart"
      :initial_date_end="custodyDateEnd"
      :start_date_min="custodyPickerMin"
      :start_date_max="custodyPickerMax"
      :end_date_min="custodyPickerMin"
      :end_date_max="custodyPickerMax"
      @doneFilter="handleDoneFilter"
    />

    <checks-table
      :items="allChecks"
      :loading="loading"
      :table-search="tableSearch"
      @doneUpdate="handleDoneUpdate"
      @doneReturned="handleDoneReturned"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FilterData from '@/components/shared/FilterData.vue'

export default {
  name: 'OpenChecks',
  components: {
    ChecksTable: () => import('./shared/ChecksTable'),
    FilterData,
  },
  data() {
    const min = this.$moment().add(1, 'day').format('YYYY-MM-DD')
    const max = this.$moment().add(5, 'years').endOf('year').format('YYYY-MM-DD')
    return {
      loading: false,
      saving: false,
      local_filter: {},
      custodyPickerMin: min,
      custodyPickerMax: max,
      custodyDateStart: min,
      custodyDateEnd: max,
    }
  },
  computed: {
    tableSearch() {
      return (this.local_filter && this.local_filter.query) ? String(this.local_filter.query) : ''
    },
    ...mapState({
      allChecks: state => state.Check.allChecks,
    }),
  },
  methods: {
    handleDoneFilter(e) {
      this.local_filter = { ...e }
      this.getChecks()
    },
    handleDoneUpdate() {
      this.getChecks()
    },
    handleDoneReturned() {
      this.getChecks()
    },
    getChecks() {
      this.loading = true
      const CONCLUDED_STATUS_ID = 16
      const CONFIRMED_STATUS_ID = 17

      const filters = {
        modality_ids: [this.activeModalityId],
        status_ids: [CONCLUDED_STATUS_ID, CONFIRMED_STATUS_ID],
        ...this.local_filter,
      }
      if (filters.start_date) {
        filters.start_date = this.$moment(filters.start_date).startOf('day').add(-3, 'hours').toISOString()
      }
      if (filters.end_date) {
        filters.end_date = this.$moment(filters.end_date).endOf('day').add(-3, 'hours').toISOString()
      }
      this.$emit('doneFilter', { ...filters })
      if (this.activeModalityId) {
        this.indexChecks(filters).finally(() => {
          this.loading = false
        })
      } else {
        this.loading = false
      }
    },
    ...mapActions({
      indexChecks: 'Check/index'
    })
  },

  watch: {
    activeModalityId() {
      this.getChecks()
    },
  }
}
</script>
